(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-option-dropdown"] && !Shopify.designMode) return;
  try {
    class ScarnattiVariantDropdown extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.trigger = this.querySelector('[role="combobox"]');
      this.list = this.querySelector('[role="listbox"]');
      this.choices = [...this.querySelectorAll('[role="option"]')];
      this.valueLabel = this.querySelector('[data-dropdown-value]');
      this.giftValue = this.querySelector('[data-dropdown-gift-value]');
      this.controller = new AbortController();
      const events = { signal: this.controller.signal };
      this.trigger.hidden = false;
      this.querySelector('.scarnatti-option__native').hidden = true;
      this.closest('.product-form__input').querySelector('label').setAttribute('for', this.trigger.id);
      this.trigger.addEventListener('click', () => this.setOpen(this.list.hidden), events);
      this.trigger.addEventListener('keydown', (event) => this.onKeydown(event), events);
      this.list.addEventListener('pointerdown', (event) => event.preventDefault(), events);
      this.list.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-dropdown-index]');
        if (choice) this.choose(Number(choice.dataset.dropdownIndex));
      }, events);
      this.select.addEventListener('change', () => this.sync(), events);
      for (const type of ['pointerdown', 'focusin']) {
        document.addEventListener(type, (event) => {
          if (!this.contains(event.target)) this.setOpen(false);
        }, events);
      }
      const reposition = (event) => {
        if (!this.list.hidden && !this.list.contains(event.target)) this.updatePosition();
      };
      window.addEventListener('scroll', reposition, { ...events, passive: true, capture: true });
      window.addEventListener('resize', reposition, events);
      window.visualViewport?.addEventListener('resize', reposition, events);
      window.visualViewport?.addEventListener('scroll', reposition, events);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.select, { subtree: true, childList: true, characterData: true, attributes: true });
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    sync() {
      this.valueLabel.textContent = this.select.value;
      this.choices.forEach((choice, index) => {
        const option = this.select.options[index];
        choice.setAttribute('aria-selected', String(option.selected));
        choice.querySelector('[data-dropdown-label]').textContent = option.textContent.trim();
        choice.classList.toggle('is-soldout', option.classList.contains('soldout'));
      });
      const gift = this.choices[this.select.selectedIndex]?.querySelector('[data-dropdown-gift]');
      this.giftValue.hidden = !gift;
      this.giftValue.className = gift ? gift.className : '';
      this.giftValue.innerHTML = gift ? gift.innerHTML : '';
    }

    setOpen(open) {
      if (open) {
        this.sync();
        document.querySelectorAll('scarnatti-variant-dropdown').forEach((dropdown) => {
          if (dropdown !== this) dropdown.setOpen(false);
        });
      }
      this.list.hidden = !open;
      this.trigger.setAttribute('aria-expanded', String(open));
      if (open) {
        this.updatePosition();
        if (!this.list.hidden) this.activate(this.select.selectedIndex);
      }
      else this.trigger.removeAttribute('aria-activedescendant');
    }

    updatePosition() {
      const rect = this.trigger.getBoundingClientRect();
      const viewportTop = window.visualViewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (window.visualViewport?.height || window.innerHeight);
      if (rect.bottom <= viewportTop + 12 || rect.top >= viewportBottom - 12) {
        this.setOpen(false);
        return;
      }
      const below = Math.max(0, viewportBottom - rect.bottom - 18);
      const above = Math.max(0, rect.top - viewportTop - 18);
      const cap = Math.min(window.innerWidth < 768 ? 250 : 230, (viewportBottom - viewportTop) * .45);
      const opensAbove = below < cap && above > below;
      this.list.dataset.side = opensAbove ? 'above' : 'below';
      this.list.style.maxHeight = `${Math.min(cap, opensAbove ? above : below)}px`;
    }

    activate(index) {
      this.activeIndex = Math.max(0, Math.min(index, this.choices.length - 1));
      this.choices.forEach((choice, position) => choice.classList.toggle('is-active', position === this.activeIndex));
      const choice = this.choices[this.activeIndex];
      this.trigger.setAttribute('aria-activedescendant', choice.id);
      this.list.scrollTop = Math.max(0, choice.offsetTop - (this.list.clientHeight - choice.offsetHeight) / 2);
    }

    choose(index) {
      const changed = this.select.selectedIndex !== index;
      this.select.selectedIndex = index;
      this.setOpen(false);
      this.sync();
      this.trigger.focus({ preventScroll: true });
      if (changed) this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onKeydown(event) {
      const open = !this.list.hidden;
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        if (!open) this.setOpen(true);
        if (event.key === 'Home') this.activate(0);
        else if (event.key === 'End') this.activate(this.choices.length - 1);
        else if (open) this.activate(this.activeIndex + (event.key === 'ArrowDown' ? 1 : -1));
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (open) this.choose(this.activeIndex);
        else this.setOpen(true);
      } else if (event.key === 'Escape' || event.key === 'Tab') {
        if (open && event.key === 'Escape') event.preventDefault();
        this.setOpen(false);
      } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault();
        this.search = Date.now() - (this.searchTime || 0) > 700 ? event.key : (this.search || '') + event.key;
        this.searchTime = Date.now();
        if (!open) this.setOpen(true);
        const index = [...this.select.options].findIndex((option) => option.value.toLowerCase().startsWith(this.search.toLowerCase()));
        if (index >= 0) this.activate(index);
      }
    }
  }
  if (!customElements.get('scarnatti-variant-dropdown')) {
    customElements.define('scarnatti-variant-dropdown', ScarnattiVariantDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-other"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-offer-card')) {
    customElements.define('gift-offer-card', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.offerEnd);
        this.timer = this.querySelector('[data-gift-timer]');
        this.timerValues = this.querySelectorAll('[data-gift-value]');
        if (!Number.isFinite(this.deadline) || !this.timer) return;
        this.tick();
        if (this.deadline > Date.now()) this.clock = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.clock);
      }

      tick() {
        const remaining = this.deadline - Date.now();
        if (remaining <= 0) {
          clearInterval(this.clock);
          (this.closest('.productView-otherProduct') || this).hidden = true;
          return;
        }
        const values = [
          Math.floor(remaining / 86400000),
          Math.floor(remaining / 3600000) % 24,
          Math.floor(remaining / 60000) % 60,
          Math.floor(remaining / 1000) % 60
        ];
        this.timerValues.forEach((element, index) => {
          element.textContent = String(values[index]).padStart(2, '0');
        });
        this.timer.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
